module.exports = __webpack_public_path__ + "img/logo-top-desktop.138367b5.png";